<ng-template #commitInfoPopover>
  <adm4-commit-info [commitInfo]='remoteCommitInfo'></adm4-commit-info>
</ng-template>

@if (shouldShowDiff) {
  <div class='diff-view-element-container'>
    <div class='remote'>
      @if (shouldShowRemote) {
        <div class='change-info'>
          @if (hasRemoteCommitInfo) {
            <span> published by
              <strong>{{remoteCommitInfo.committer.name}},
                <span class="date" [ngbTooltip]='commitInfoPopover' placement='top'>
                  {{remoteCommitInfo.committer.when | customDate}}
                </span>
              </strong>
            </span>
            @if (isDoneByAnotherUser(remoteCommitInfo.committer.name)) {
              <img width="16" height="16" src='assets/warningUserChanges24px.png'
                alt="Icon warning about user changes"/>
            }
          }
        </div>
        <div [class.change-content-box]='boxed'>
          <div [class.unmodified]='isUnmodified'>
            <ng-content select='[remote]'></ng-content>
          </div>
        </div>
      }
    </div>
    <div class='local'>
      <div class='change-info'>
        @if (hasLocalInfo) {
          <span> {{localChangeInfo.localStatus | lowercase}} by
            <strong>{{localChangeInfo.localAuthor}},
              <span class="date">
                {{localChangeInfo.localDate | customDate}}
              </span>
            </strong>
          </span>
          @if (isDoneByAnotherUser(localChangeInfo.localAuthor)) {
            <img width="16" height="16" src='assets/warningUserChanges24px.png'
              alt="Icon warning about user changes"/>
          }
        }
      </div>
      <div [class.change-content-box]='boxed'>
        <div [class.unmodified]='isUnmodified'>
          @if (shouldShowLocal) {
            <ng-content select='[local]'></ng-content>
          } @else {
            <div class='deleted-local-label'>
              {{localFallbackLabel}}
            </div>
          }
        </div>
      </div>
    </div>
  </div>
}